export class RoomSetting {
    public defaultWallDepth: number = 0;
}